import { getToken } from '../../utils/system';
import { Module } from 'vuex';

export interface IUserState {
  token: string;
  name: string;
  avatar: string;
  introduction: string;
  roles: string[];
  menus: string[];
  currentTab: string;
  privilegeBtns: [];
}

const user: Module<IUserState, {}> = {
  namespaced: true,
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    menus: [],
    currentTab: '',
    privilegeBtns: [],
  },
  mutations: {
    SET_TOKEN: (state, token: string) => {
      state.token = token;
    },
    SET_INTRODUCTION: (state, introduction: string) => {
      state.introduction = introduction;
    },
    SET_NAME: (state, name: string) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar: string) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles: string[]) => {
      state.roles = roles;
    },
    SET_TAB: (state, currentTab: string) => {
      state.currentTab = currentTab;
    },
    SET_PRIVILEGES_BTN: (state, data: any) => {
      state.privilegeBtns = data;
    },
    SET_MENU: (state, data: any) => {
      state.menus = data;
    },
  },
  actions: {
    loginByToken({ commit }, token: string) {
      commit('SET_TOKEN', token);
    },
    setTab({ commit }, res: { data: string[] }) {
      commit('SET_TAB', res.data);
    },
    getUserInfo({ commit }, backgroundMenus) {
      return new Promise((resolve) => {
        commit('SET_MENU', backgroundMenus);
        // $dts.login?.getUserPermission.request({}).then((res) => {
        //   commit('SET_PRIVILEGES_BTN', res.data);
        // });
        resolve('');
      });
    },
    removeStoreToken({ commit }) {
      commit('SET_TOKEN', '');
    },
  },
};

export default user;
